(() => {
  const normalize = (value) => value.trim().replace(/\s+/g, ' ').toUpperCase();

  const initAdsBFragranceDetails = () => {
    const productWidget = document.getElementById('product-widget');
    const root = productWidget?.querySelector('[data-ads-b-fragrance-details]');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const emptyState = root.querySelector('[data-ads-b-fragrance-empty]');
    const panels = Array.from(root.querySelectorAll('[data-fragrance-key]'));

    const showForValue = (value) => {
      const key = normalize(value || '');
      let matched = false;

      panels.forEach((panel) => {
        const panelKey = normalize(panel.dataset.fragranceKey || '');
        const isMatch = key === panelKey;
        panel.hidden = !isMatch;
        if (isMatch) matched = true;
      });

      if (emptyState) emptyState.hidden = matched;
    };

    const getValueFromWidget = () => {
      const picker = productWidget.querySelector('variant-selects');
      if (!picker) return '';

      const selectedVariant = picker.querySelector('[data-selected-variant]');
      if (selectedVariant?.textContent) {
        try {
          const variant = JSON.parse(selectedVariant.textContent);
          return variant.option1 || variant.public_title || variant.title || '';
        } catch (error) {
          /* ignore malformed JSON */
        }
      }

      const radio = picker.querySelector('input[type="radio"]:checked');
      if (radio?.value) return radio.value;

      const select = picker.querySelector('select');
      return select?.value || '';
    };

    const syncFromPicker = () => showForValue(getValueFromWidget());

    productWidget.addEventListener('change', (event) => {
      if (!event.target.closest('variant-selects')) return;
      syncFromPicker();
    });

    productWidget.addEventListener('click', (event) => {
      if (!event.target.closest('.product-form__input--pill label')) return;
      requestAnimationFrame(syncFromPicker);
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      const sectionId = productWidget.dataset.section;

      subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, ({ data }) => {
        if (!data?.event?.target || !productWidget.contains(data.event.target)) return;

        const value = data.target?.value || data.event.target?.value;
        if (value) {
          showForValue(value);
          return;
        }

        syncFromPicker();
      });

      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (sectionId && data?.sectionId && data.sectionId !== sectionId) return;

        const value = data?.variant?.option1 || data?.variant?.public_title || data?.variant?.title;
        if (value) {
          showForValue(value);
          return;
        }

        syncFromPicker();
      });
    }

    syncFromPicker();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAdsBFragranceDetails);
  } else {
    initAdsBFragranceDetails();
  }

  document.addEventListener('product-info:loaded', initAdsBFragranceDetails);
})();
